import React from 'react';
import Helmet from 'react-helmet';

const PageMeta = _ => {
  return (
    <Helmet
      title={`Home`} >
    </Helmet>
  )
}

export default PageMeta;
